import React from 'react';

const Admin: React.FC = () => {
  return (
    <main className="page page--admin">
      <h1>Admin Dashboard</h1>
    </main>
  );
};

export default Admin;
